<div class="statsPopup" *ngIf="stats.home">
  <h5>
    <ng-container *ngIf="!stats.home.player">
      {{ 'Team data in this zone' | translate }}      
    </ng-container>
    <ng-container *ngIf="stats.home.player">
      {{ 'Player data in this zone' | translate }}      
    </ng-container>
  </h5>
  <h6>
    {{ stats.home.player ? (stats.home.player.number + '. ') : '' }}
    {{ stats.home.player ? stats.home.player.name : stats.home.name }}
    <span *ngIf="stats.home.player">{{ stats.home.name }}</span>
  </h6>
  <div class="stats">
    <p class="main">{{ stats.home.points }} <span class="unit">{{ 'points' | translate }}</span></p>
    <p>{{ stats.home.shots - stats.home.failures }}<span> / {{ stats.home.shots }}</span> <span class="unit">{{ 'shots' | translate }}</span></p>
    <p><span class="square" [style.background-color]="stats.home.accuracyColor"></span>{{ stats.home.accuracy }} <span>%</span> <span class="unit">{{ 'accuracy' | translate }}</span></p>
  </div>
  <div class="opponent" *ngIf="stats.visitor && (!stats.home.player || stats.visitor.player)">
    <div class="stats">
      <p class="main">{{ stats.visitor.points }}</p>
      <p>{{ stats.visitor.shots - stats.visitor.failures }}<span> / {{ stats.visitor.shots }}</span></p>
      <p><span class="square" [style.background-color]="stats.visitor.accuracyColor"></span>{{ stats.visitor.accuracy }} <span>%</span></p>
    </div>
    <h6>{{ stats.visitor.player ? stats.visitor.player.name : stats.visitor.name }} <span *ngIf="stats.visitor.player">{{ stats.visitor.name }}</span></h6>
  </div>
</div>